import { faHomeAlt } from "@fortawesome/free-regular-svg-icons";
import { ServiceCard } from "../../components/cards/service-card";
import { SiteHeader } from "../../components/header/header";
import { cardsData } from "../../helpers/service-card-data";
import { SiteFooter } from "../../components/footer/footer";
import FadeAnim from "../../components/utils/fade-anim";

export const HomePage = () => {

    return (
        <div
            className="flx-col"
        >
            <SiteHeader title={"Home"} />
            <div className="app-pg">
                <div className="overlay-box">
                    <FadeAnim>
                        <h1>Professionelle Wohnungs- und Büroreinigung in Berlin</h1>
                        <div className="lg-txt">
                            24-Stunden-Reinigungsdienste in Berlin und Brandenburg verfügbar
                        </div>
                    </FadeAnim>


                </div>
                <section className="service-section">
                    <div className="page-caption flx-rw c-jt c-al">Reinigungsdienste</div>
                    <div className="services-boxes">
                        {cardsData.map((data, indx) => {
                            return (
                                <ServiceCard
                                    cardData={data}
                                    key={indx}
                                />
                            )
                        })}
                    </div>
                </section>
                <div className="flx-rw c-al c-jt">
                    <button
                        className="request-button"
                        onClick={() => window.location.href = '/cleanerrequest'}
                    >
                        Reinigungskraft anfordern
                    </button>
                </div>
            </div>
        </div>
    )
}